export enum RoleType {
  NONE = "none",
  ADMIN = "administrator",
  MASTER = "master",
}
